import { db_user } from "../firestore_user";

/** Firestore `profiles/{uid}` field — set when account was created via the distribution portal. */
export const CREATED_VIA_DISTRIBUTION_FIELD = "createdViaDistribution";

/** Wait between reads while auth onCreate may still be writing the profile. */
const RETRY_DELAYS_MS = [500, 1000, 1500, 2000];

function sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

/**
 * Call from FirebaseUI `signInSuccessWithAuthResult`. Only new sign-ups on this
 * portal get createdViaDistribution — returning users from elsewhere do not.
 * @param {firebase.auth.UserCredential | undefined} authResult
 */
export function onDistributionAuthResult(authResult) {
  if (!authResult?.additionalUserInfo?.isNewUser) return;
  const uid = authResult.user?.uid;
  if (!uid) return;
  syncDistributionProfile(uid);
}

/**
 * Sets createdViaDistribution on an existing profile (auth onCreate). Never
 * creates a profile doc. Retries while onCreate may still be writing the doc.
 * @param {string | undefined | null} uid
 * @returns {Promise<boolean>} true if the flag was updated
 */
export async function syncDistributionProfile(uid) {
  const id = uid?.trim();
  if (!id || !db_user) return false;

  const ref = db_user.collection("profiles").doc(id);
  const maxAttempts = RETRY_DELAYS_MS.length + 1;

  for (let attempt = 0; attempt < maxAttempts; attempt++) {
    if (attempt > 0) {
      await sleep(RETRY_DELAYS_MS[attempt - 1]);
    }

    try {
      const snap = await ref.get();
      if (!snap.exists) continue;

      if (snap.data()?.[CREATED_VIA_DISTRIBUTION_FIELD] === true) return false;

      await ref.update({ [CREATED_VIA_DISTRIBUTION_FIELD]: true });
      return true;
    } catch (err) {
      console.warn("syncDistributionProfile failed", err);
      return false;
    }
  }

  console.warn(
    "syncDistributionProfile: profile not found after retries (auth onCreate may still be pending)",
    { uid: id }
  );
  return false;
}
